<ng-container *ngIf="hasThumbnail(); else noThumbnail">
  <div [ngSwitch]="url">
    <div class="circle" *ngSwitchCase=""><mat-icon class="pending">pending</mat-icon></div>
    <div class="circle" *ngSwitchCase="'ThumbnailComponentError'"><mat-icon class="error">error</mat-icon></div>
    <div *ngSwitchDefault>
      <picture>
        <img style="max-height: 200px; max-width: 200px;" [src]="url | safe" [width]="dims[0]" [height]="dims[1]">
      </picture>
    </div>
  </div>
</ng-container>

<ng-template #noThumbnail>
  <div class="circle">
    <mat-icon class="remove_circle_outline">remove_circle_outline</mat-icon>
  </div>
</ng-template>
